<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  [isShowModal]="false"
  [erroremessage]="erroremessage"
  [defaultHeight]="35"
  [hasDefault]="false"
  (valueChangeByApiName)="onChanged($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="formGroup !== undefined && isOkForLoad">
    <accvoucher-detail
      class="detail"
      #detail
      (valueChanges)="onValueChanges($event)"
      [gridheight]="gridheight()"
      [detailLedgerLevel]="detailLedgerLevel"
      [isAdd]="!isNoValidForEdit()"
      [isEdit]="!isNoValidForEdit()"
      [isDelete]="!isNoValidForEdit()"
      [headerTitleToDetailTitle]="headerTitleToDetailTitle"
      [columns]="accVoucerherDetailcolumns"
      [RowNumberName]="'RowNumber'"
      [accountInfo]="!selected ? accountInf : ''"
      (showDetail)="setSelected()"
      [(dataList)]="model.AccVoucherDetails">
    </accvoucher-detail>

    <div class="detail-footer" *ngIf="selected && formGroup && isOkForLoad && detailLedgerLevel !== undefined">
      <div class="detail-footer-item">
        <form-control-model [defaultHeight]="30" [isShowModal]="false" [columns]="SubLedgerColumns" [group]="formGroup" [model]="model">
        </form-control-model>
      </div>
      <div class="detail-footer-item">
        <form-control-model [defaultHeight]="30" [isShowModal]="false" [columns]="DetailLedger2Columns" [group]="formGroup" [model]="model">
        </form-control-model>
      </div>
      <div class="detail-footer-item">
        <form-control-model [defaultHeight]="30" [isShowModal]="false" [columns]="DetailLedger5Columns" [group]="formGroup" [model]="model">
        </form-control-model>
      </div>
      <div class="detail-footer-item">
        <div class="detail-footer-title">بدهکار :</div>
        <form-control-model [defaultHeight]="30" [isShowModal]="false" [columns]="SummeryDebitcolumns" [group]="formGroup" [model]="model">
        </form-control-model>
      </div>
      <div class="detail-footer-item">
        <div class="detail-footer-title">بستانکار :</div>
        <form-control-model [defaultHeight]="30" [isShowModal]="false" [columns]="SummeryCreditcolumns" [group]="formGroup" [model]="model">
        </form-control-model>
      </div>
    </div>
  </ng-container>
  <ng-container class="footer">
    <ssg-button class="btnstyle" (click)="ngOnInit()" data-tooltip="top" tooltip="بازخوانی اطلاعات" icon="icon-refresh-o"> </ssg-button>
    <ssg-button icon="icon-list-f" buttontype="button" (click)="loadVoucherList()" class="btnstyle" tooltip="لیست اسناد" [disabled]="false">
    </ssg-button>
    <ssg-button icon="icon-file-document-multiple-outline" buttontype="button" (click)="newVoucher()" class="btnstyle" tooltip="سند جدید">
    </ssg-button>
    <ssg-button
      icon="icon-delete_forever-o"
      buttontype="button"
      (click)="deleteVoucher()"
      class="btnstyle"
      tooltip="حذف سند"
      [disabled]="model?.StatusKindCode > 2 || isNoValidForEdit()">
    </ssg-button>
    <ssg-button
      icon="icon-Takenote"
      buttontype="button"
      (click)="accountWrite()"
      class="btnstyle"
      tooltip="ثبت یاداشت"
      [disabled]="model?.StatusKindCode > 2 || isNoValidForEdit()">
    </ssg-button>
    <ssg-button
      icon="icon-Temporaryregister"
      (click)="accountInspection()"
      buttontype="button"
      class="btnstyle"
      tooltip="ثبت موقت"
      [disabled]="model?.StatusKindCode > 2 || model.SystemKindCode > 1 || isNoValidForEdit()">
    </ssg-button>
    <ssg-button
      icon="icon-Documentreview"
      buttontype="button"
      (click)="accountConfirm()"
      class="btnstyle"
      tooltip="{{ confirmLabel }}"
      [disabled]="model?.StatusKindCode <= 1 || model?.StatusKindCode > 3 || isNewRow">
    </ssg-button>
    <ssg-menu *ngIf="!isNewRow" icon="icon-print-o" class="btnstyle" tooltip="چاپ">
      <ng-container class="menuitem">
        <div>
          <div *ngFor="let report of reportKinds" class="reportbtn">
            <button class="btn" (click)="changeReport(report.value)">{{ report.name }}</button>
          </div>
        </div>
      </ng-container>
    </ssg-menu>
  </ng-container>
</dynamic-form>
